import type { Task } from '@cartwheel/api/v1'
import { formatDate, titleize } from '@cartwheel/string-utils'
import type React from 'react'
import { TaskAssigneePicker } from './task-assignee-picker'

export function TaskMetadataCard({ task }: { task: Task }) {
  const isOverdue = task.due_at ? new Date(task.due_at).getTime() < Date.now() : false

  return (
    <div className="rounded-lg border border-sand bg-white px-6 py-5 shadow-sm">
      <MetadataRow label="Assignee">
        <TaskAssigneePicker
          taskId={task.id}
          queue={task.queue}
          assignee={task.assignee}
          disabled={!task.capabilities.can_assign}
        />
      </MetadataRow>
      <MetadataRow label="Created">
        <span className="text-sm text-charcoal">{formatDate(task.created_at)}</span>
      </MetadataRow>
      {task.due_at && (
        <MetadataRow label="Due">
          <span className={`text-sm ${isOverdue ? 'text-brick-light' : 'text-charcoal'}`}>
            {formatDate(task.due_at)}
          </span>
        </MetadataRow>
      )}
      <MetadataRow label="Workflow">
        <span className="text-sm text-charcoal">
          {task.workflow?.type ? titleize(task.workflow.type) : '—'}
        </span>
      </MetadataRow>
    </div>
  )
}

function MetadataRow({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <div className="flex min-h-10 items-center gap-6">
      <span className="w-[62px] shrink-0 text-sm font-medium text-charcoal">{label}</span>
      <div className="min-w-0 flex-1">{children}</div>
    </div>
  )
}
